import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const QnA007 = ({ isOpened, onChangeOpenedFlag }) => {
    const { t } = useTranslation();

    useEffect(() => {
        let content = document.getElementById("qna7");

        if (isOpened) {
            content.style.maxHeight = content.scrollHeight + "px";
        } else {
            content.style.maxHeight = null;
        }
    }, [isOpened]);

    return (
        <div className="accordion">
            <div className="accordion-title" onClick={() => onChangeOpenedFlag(6)}>
                <span className="hiclasstv-deepDarkgrey-text button">
                    <b>7. {t("FAQ_질문_7", { ns: "info" })}</b>
                </span>
            </div>
            <div className="accordion-content hiclasstv-darkgrey-text" id="qna7">
                <span className="d-flex" style={{ minWidth: 'max-content' }}>A.&nbsp;</span>
                <p>
                    {t("FAQ_질문_7_답변_1", { ns: "info" })}<br />
                    {t("FAQ_질문_7_답변_2", { ns: "info" })}
                </p>
            </div>
        </div>
    );
}

export default QnA007;